import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const MobileGender = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, returnImage  }) => {
  return (
    <div className="gender-mobile" data-model-id="16747:1529">

      <div className="frame-4">
        <div className="title">
          <div className="heading">What's your gender?</div>
        </div>

        <div className="frame-5">
          <div className="sex-options">
            <div className="div-2" onClick={() => {clickNext("female")}}>
              <Image src={returnImage(true)} alt="Female image" className="img" />

              <div className="text-wrapper">Female</div>
            </div>

            <div className="div-2" onClick={() => {clickNext("male")}}>
              <Image src={returnImage(false)} alt="Male image" className="img" />

              <div className="text-wrapper">Male</div>
            </div>
          </div>

          <button className="button-2" onClick={() => {clickNext("female")}}>
            <Image src="/static/image/questionnaire/fasting/gender/icon-nonbinary.png" alt="Icon nonbinary" className="icon-nonbinary" />

            <div className="non-binary-text">Non-binary</div>
          </button>
        </div>
      </div>
    </div>
  );
};
